import { combineReducers } from "redux";

import mainReducer from "./config";
import historyReducer from "./historyReducer";

export default combineReducers({
    config: mainReducer,
    history: historyReducer
});


// WEBPACK FOOTER //
// ./src/redux/reducer.js